import React, { useState } from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { compose } from "recompose";
import Button from "@material-ui/core/Button";
import Add from "@material-ui/icons/Add";
import { showModal } from "../../../redux/actions";
import InviteTeamMember from "../InviteTeamMember";

const AddTeamMembers = ({ onShowModal, intl }) => {
  const [circleId] = useState(null);

  const onAddClick = () => {
    onShowModal(circleId);
  };

  return (
    <Button
      onClick={onAddClick}
      data-testid="add-member-button"
      style={{ margin: "8px -16px 0 32px" }}
      variant="text"
      color="primary"
      size="large"
    >
      {intl.formatMessage({ id: "app.userProfile.addTeamMemberButtonText" })}
      <Add viewBox="-3 -3 30 30" />
    </Button>
  );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  onShowModal: (circleId) =>
    dispatch(showModal(InviteTeamMember, { circleId: circleId })),
});

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl,
);

export default enhance(AddTeamMembers);
